import api from '../utils/axiosConfig';

export const taskService = {
  // Get all tasks for the authenticated user
  getAllTasks: async () => {
    const response = await api.get('/api/tasks');
    return response.data;
  },

  // Get tasks for a specific job
  getTasksByJob: async (jobId) => {
    const response = await api.get(`/api/tasks/job/${jobId}`);
    return response.data;
  },

  // Get a single task by ID
  getTaskById: async (id) => {
    const response = await api.get(`/api/tasks/${id}`);
    return response.data;
  },

  // Create a new task
  createTask: async (taskData) => {
    const response = await api.post('/api/tasks', taskData);
    return response.data;
  },

  // Update a task
  updateTask: async (id, taskData) => {
    const response = await api.put(`/api/tasks/${id}`, taskData);
    return response.data;
  },

  // Toggle task completion status
  toggleTaskComplete: async (id, completed) => {
    const response = await api.put(`/api/tasks/${id}/complete`, { completed });
    return response.data;
  },

  // Delete a task
  deleteTask: async (id) => {
    const response = await api.delete(`/api/tasks/${id}`);
    return response.data;
  }
}; 